import { css } from '@emotion/react';
import { ProgressBar, Text } from '@zapier/design-system';
import { useTranslations } from 'next-intl';

const styleRoot = css`
  display: grid;
  justify-content: stretch;
  max-width: calc(80px * 2 + var(--zds-space-16));
  margin-inline: auto;
  gap: var(--zds-space-8);
  margin-bottom: var(--zds-space-24);
`;

export function WorkflowAPIHeader() {
  const t = useTranslations('workflow-api-header');

  return (
    <div css={styleRoot}>
      <ProgressBar value={1 / 2} />
      <Text tag="p" type="MinimalPrint3Multiline" textAlign="center">
        {t('step-progress')}
      </Text>
    </div>
  );
}
